import React, { FunctionComponent } from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

interface NavigationProps {
  show: boolean;
  hideNavigation(): void;
}

interface NavigationWrapperProps {
  show: boolean;
}

const NavigationWrapper = styled.div<NavigationWrapperProps>`
  position: fixed;
  top: 6vh;
  z-index: 10;
  right: ${(props) => (props.show ? "0px" : "-240px")};
  opacity: ${(props) => (props.show ? 1 : 0)};
  width: 240px;
  height: 94vh;
  background: #fff;
  transition: all 0.3s ease-in-out;
  box-shadow: ${(props) =>
    props.show ? "0 0 15px 0 rgba(0, 0, 0, 0.25)" : "none"};
`;

const NavigationMenu = styled.ul``;

const NavigationMenuItem = styled.li`
  list-style: none;
`;

const NavigationMenuItemLink = styled(NavLink)`
  display: block;
  padding: 10px;
  text-decoration: none;
  color: inherit;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
`;

export const Navigation: FunctionComponent<NavigationProps> = ({
  show,
  hideNavigation,
}) => {
  return (
    <NavigationWrapper show={show}>
      <NavigationMenu>
        <NavigationMenuItem>
          <NavigationMenuItemLink to="/" onClick={hideNavigation}>
            Accueil
          </NavigationMenuItemLink>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <NavigationMenuItemLink to="/deconnexion" onClick={hideNavigation}>
            Déconnexion
          </NavigationMenuItemLink>
        </NavigationMenuItem>
      </NavigationMenu>
    </NavigationWrapper>
  );
};
